import { product } from '@/Services/Axios'
import { facilita } from '@/global'

const state = {
    products: [],
    product: {},
}

const getters = {
    products: (state) => state.products,
    product: (state) => state.product,
}

const actions = {
    async setProduct({ commit }) {
        const response = await product.get(facilita.productID)
        commit('SET_PRODUCT', response.data.data[0])

        return response
    },
}

const mutations = {
    SET_PRODUCTS: (state, payload) => (state.products = payload),
    SET_PRODUCT: (state, payload) => (state.product = payload),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
